import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import LinearProgress from '@material-ui/core/LinearProgress';

import ListItem from '../../components/UI/List/ListItem/ListItem';
import * as actions from '../../store/actions/index';

const LTrain = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const trainRoutes = useSelector((state) => state.cta.ctaTrainRoutes);
    const isLoading = useSelector((state) => state.cta.loading);

    const onLoadCtaTrainRoutes = useCallback(
        () => dispatch(actions.loadCtaTrainRoutes()),
        [dispatch]
    );

    const onSelectedTrainLine= (trainLineColorId) => {
        dispatch(actions.setSelectedTrainLine(trainLineColorId));
        history.push('/trainStations');
    }

    useEffect(() => {
        onLoadCtaTrainRoutes();
    }, [onLoadCtaTrainRoutes]);

    if (isLoading) {
        return <LinearProgress />;
    } 

    return (
        <React.Fragment>
            {trainRoutes.map((route) => (
                <ListItem key={route.routeId} item={route} onClick={onSelectedTrainLine}/>
            ))}
        </React.Fragment>
    );
};

export default LTrain;